const CHECK_NEW_ORDERS_ARCHIVED = "CHECK_NEW_ORDERS_ARCHIVED";
const CHECK_NEW_ORDERS_ARCHIVED_SUCCESS = "CHECK_NEW_ORDERS_ARCHIVED_SUCCESS";
const CHECK_NEW_ORDERS_ARCHIVED_FAILURE = "CHECK_NEW_ORDERS_ARCHIVED_FAILURE";
const CLEAR_CHECK_NEW_ORDERS_ARCHIVED = "CLEAR_CHECK_NEW_ORDERS_ARCHIVED";
const checkNewOrdersArchivedSymbols = {
  CHECK_NEW_ORDERS_ARCHIVED_SUCCESS,
  CHECK_NEW_ORDERS_ARCHIVED_FAILURE,
  CHECK_NEW_ORDERS_ARCHIVED,
  CLEAR_CHECK_NEW_ORDERS_ARCHIVED,
};
export default checkNewOrdersArchivedSymbols;
